<template>
  <datepicker class="form-control" :class="className"
              :locale="locale"
              :inputFormat="dateFormat"
              v-model="date"
              @keyup.enter="this.$emit('keyupEnter', $event.target.value)"
              :style="{background: !disabled ? '#fff' : null}"
              :clearable="clearable && !disabled" :disabled="disabled"
              :typeable="!disabled"
              @change="changeValue"
              placeholder="ДД.ММ.ГГГГ"
  />
  <div class="invalid-msg" v-if="v$.date.$error">
    <template v-if="v$.date.requiredValidator.$invalid">Поле обязательно для заполнения</template>
    <template v-else-if="v$.date.formatValidator.$invalid">Неверный формат даты</template>
    <template v-else-if="v$.date.dateValidator.$invalid">Укажите корректную дату - не больше текущей</template>
    <template v-else-if="v$.date.minAgeValidator.$invalid">
      Возраст должен быть не менее {{ minAge }} лет
    </template>
    <template v-else-if="v$.date.maxDateValidator.$invalid">
      Укажите корректную дату - не больше {{ $momentFormat(maxDate, 'DD.MM.YYYY') }}
    </template>
  </div>
</template>
<script>
import {ru} from 'date-fns/locale'
import moment from 'moment'
import {useVuelidate} from '@vuelidate/core'
import {helpers} from "@vuelidate/validators";

const requiredValidator = (required, scope) =>
    helpers.withParams(
        {type: 'requiredValidator'},
        (value) => {
          if (!required)
            return true;
          return {
            $valid: value && value !== '',
            extraParams: {scope: scope}
          }
        }
    );

const dateValidator = (notFuture, scope) =>
    helpers.withParams(
        {type: 'dateValidator'},
        (value) => {
          if (!notFuture || !value || value === '')
            return true;
          return {
            $valid: Date.parse(value) <= Date.now(),
            extraParams: {scope: scope}
          }
        }
    );

const formatValidator = (scope) =>
    helpers.withParams(
        {type: 'formatValidator'},
        (value) => {
          if (!value || value === '' )
            return true;
          return {
            $valid: !isNaN(Date.parse(value)),
            extraParams: {scope: scope}
          }
        }
    );

const minAgeValidator = (minAge, scope) =>
  helpers.withParams(
    { type: 'minAgeValidator' },
    (value) => {
      if (!minAge || !value)
        return true;

      const birthDate = moment(value);
      const age = moment().diff(birthDate, 'years');

      return {
        $valid: age >= minAge,
        extraParams: { scope }
      };
    }
  );

const maxDateValidator = (getMaxDate, scope) =>
  helpers.withParams(
    { type: 'maxDateValidator' },
    (value) => {
      const maxDate = getMaxDate();

      if (!maxDate || !value)
        return true;

      const valueDate = moment(value);
      const limitDate = moment(maxDate);

      return {
        $valid: valueDate.isSameOrBefore(limitDate, 'day'),
        extraParams: { scope }
      };
    }
  );


export default {
  props: {
    modelValue: String,
    clearable: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    scopeName: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    notFuture: {
      type: Boolean,
      default: false
    },
    minAge: {
      type: Number,
      default: null
    },
    maxDate: {
      type: [String, Date],
      default: null
    }
  },
  created() {
    if (this.modelValue)
      this.date = this.modelValue ? new Date(Date.parse(this.modelValue)) : null;
  },
  data() {
    return {
      dateFormat: 'dd.MM.y',
      date: null,
      locale: ru,   
    }
  },
  methods: {
    changeValue(newValue) {
      //this.$emit('update:modelValue', this.date != null ? moment(this.date).format("YYYY-MM-DD") : null);
      this.date = newValue.target.value && newValue.target.value !== '' ? new Date(Date.parse(moment(newValue.target.value, "DD.MM.yyyy"))) : null;
    }
  },
  computed: {
    /*date: {
      get() {
        return this.modelValue && this.modelValue !== '' ? new Date(Date.parse(this.modelValue)) : null;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }*/
  },  
  watch: {
    modelValue: function (newValue) {
      this.date = newValue && newValue !== '' ? new Date(Date.parse(newValue)) : null;
    },
    date: function (newValue) {
      this.$emit('update:modelValue', newValue != null ? moment(newValue).format("YYYY-MM-DD") : null);
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      date: {
        requiredValidator: requiredValidator(this.required, this.scopeName),
        formatValidator: formatValidator(this.scopeName),
        dateValidator: dateValidator(this.notFuture, this.scopeName),
        minAgeValidator: minAgeValidator(this.minAge, this.scopeName),
        maxDateValidator: maxDateValidator(() => this.maxDate, this.scopeName)
      }
    }
  },
}
</script>
<style lang="scss">
.patient-date__range {
  .v3dp__datepicker:last-child {
    .v3dp__popout {
      left: -90% !important;
    }
  }
}
.bottom-datepicker {
  .v3dp__datepicker {
    .v3dp__popout {
      bottom: 38px !important;
    }
  }
}
.v3dp__input_wrapper {
  position: relative;

  input {
    width: 100%;
    display: inline-block;
  }

  input.input-error {
    border-color: red;
  }

  input.input-error:focus {
    box-shadow: 0 0 0 0.25rem rgba(255, 0, 0, 0.25);
  }

  .v3dp__clearable {
    position: absolute;
    right: 10px;
    top: 6px;
    left: auto;
  }
}

.form-date-medium {
  max-width: 120px;
}

.invalid-msg {
  color: red;
  font-size: 0.75rem;
}
</style>
